/* Ess-Nische product.js (t2): Variantenwahl (Farbfelder, ?farbe=, ?variant=), Preis, Verfügbarkeit, Pflichtangaben
   und GPSR-Werte je Variante (.pv), Positionseigenschaften, Galerie mit Farbfilter, Versandschwelle mit Bon,
   Kaufleiste erst nach dem Kauf-Button, Sag mir Bescheid statt Kauf-Button bei ausverkaufter Variante, Galerie je Set
   (Maße „Ø … cm“ im Alt-Text). Vanilla ES2020, defer. */
(() => {
  const E = (window.essnische = window.essnische || {});
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const nb = (t) => String(t).replace(/ /g, ' ');
  const money = (c) => nb(E.formatMoney ? E.formatMoney(c) : (c / 100).toFixed(2).replace('.', ',') + ' €');
  const smooth = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  const say = (t) => E.announce && E.announce(t);
  const show = (el, on) => el && (el.hidden = !on);
  const txt = (el, t) => el && (el.textContent = t);
  const slug = (s) =>
    String(s || '')
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

  class Product {
    constructor(r) {
      const json = $('[data-product-json]', r);
      if (!json) return;
      this.r = r;
      this.d = JSON.parse(json.textContent);
      this.sets = $$('[data-option]', r);
      this.id = $('[data-variant-id]', r);
      this.btn = $('[data-add-button]', r);
      this.row = $('[data-buy-row]', r);
      this.qty = $('[data-product-form] [data-quantity-input]', r);
      this.sticky = $('[data-sticky-atc]', r);
      this.bis = $('[data-back-in-stock]', r);
      this.g = $('[data-gallery]', r);
      this.cartTotal = this.d.cartTotal || 0;
      this.inCart = new Set(this.d.cartVariants || []);
      this.v = this.d.variants.find((v) => String(v.id) === String(this.id && this.id.value)) || this.d.variants[0];
      r.addEventListener('change', (e) => {
        const t = e.target;
        if (t.matches('[data-option-input]')) this.change();
        else if (t.matches('[data-quantity-input]') && t.closest('[data-product-form]')) this.threshold();
      });
      r.addEventListener('click', (e) => this.click(e));
      document.addEventListener('essnische:cart:updated', (e) => {
        const c = e.detail && e.detail.cart;
        if (!c) return;
        this.cartTotal = c.total_price;
        this.inCart = new Set(c.items.map((i) => i.variant_id));
        this.threshold();
      });
      this.initGallery();
      this.initSticky();
      this.props(this.v);
      if (this.sets.length) this.states(this.sel());
      this.fromUrl();
      const done = this.bis && $('[data-bis-success], [data-bis-errors]', this.bis);
      if (done) {
        this.bis.hidden = false;
        done.scrollIntoView({ block: 'center' });
        done.focus({ preventScroll: true });
      }
    }

    sel() {
      return this.sets.map((fs) => ($('input:checked', fs) || {}).value || null);
    }

    find(o) {
      return this.d.variants.find((v) => v.options.every((x, i) => x === o[i]));
    }

    change() {
      const s = this.sel();
      this.states(s);
      this.update(this.find(s));
    }

    /* ?farbe=<Metaobjekt-Handle oder Farbname> aus Teasern (t3); ?variant= wählt Shopify selbst vor */
    fromUrl() {
      const want = slug(new URLSearchParams(location.search).get('farbe'));
      if (!want || !this.sets.length) return;
      const hits = this.d.variants.filter((v) => v.farbe === want || v.options.some((o) => slug(o) === want));
      const v = hits.find((x) => x.available) || hits[0];
      if (!v || v === this.v) return;
      this.sets.forEach((fs, i) => {
        const input = $$('[data-option-input]', fs).find((x) => x.value === v.options[i]);
        if (input) input.checked = true;
      });
      this.change();
    }

    states(s) {
      this.sets.forEach((fs, i) => {
        txt($('[data-option-selected]', fs), s[i] || '');
        $$('[data-option-input]', fs).forEach((input) => {
          const test = s.slice();
          test[i] = input.value;
          const m = this.find(test);
          const ok = !!(m && m.available);
          const wrap = input.closest('.variant-picker__value');
          wrap.classList.toggle('is-unavailable', !ok);
          show($('[data-unavailable-label]', wrap), !ok);
          if (m) txt($('[data-value-price]', wrap), money(m.price));
        });
      });
    }

    update(v) {
      const r = this.r;
      const ok = !!(v && v.available);
      this.v = v;
      if (this.id) this.id.value = v ? v.id : '';
      if (this.btn) {
        this.btn.disabled = !ok;
        txt($('[data-add-label]', this.btn), this.btn.dataset[!v ? 'labelUnavailable' : ok ? 'labelAdd' : 'labelSoldOut']);
      }
      /* Ausverkaufte Variante: „Sag mir Bescheid“ statt Menge und Kauf-Button (H08) */
      show(this.row, !(v && !ok));
      show($('[data-availability-in]', r), ok);
      show($('[data-availability-out]', r), !!v && !ok);
      show($('[data-availability-none]', r), !v);
      if (v) {
        this.price(v);
        $$('[data-pv]', r).forEach((el) => el.classList.toggle('is-current', el.dataset.pv === String(v.id)));
        $$('[data-pflicht-variant]', r).forEach((el) => txt(el, ' · ' + v.title));
        this.props(v);
        this.filter(v);
        const u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        u.searchParams.delete('farbe');
        history.replaceState(history.state, '', u);
      }
      if (this.bis) {
        show(this.bis, !!v && !ok);
        if (v) {
          const f = (k, val) => {
            const el = $(`[data-bis-${k}]`, this.bis);
            if (el) el.value = val;
          };
          f('variant', v.title);
          f('sku', v.sku || '');
          f('variant-id', v.id);
          f('body', (this.d.strings.bisBody || '').replace('[variant]', v.title));
        }
      }
      this.updateSticky();
      this.threshold();
      r.dispatchEvent(new CustomEvent('essnische:variant:change', { bubbles: true, detail: { variant: v || null, productId: this.d.id } }));
      const st = $(v ? (ok ? '[data-availability-in] .availability__state' : '[data-availability-out] .availability__state') : '[data-availability-none]', r);
      say([v && v.title, v && money(v.price), st && st.textContent.trim()].filter(Boolean).join(' – '));
    }

    price(v) {
      const r = this.r;
      const ref = typeof v.low === 'number' && v.low > v.price;
      txt($('[data-price-current]', r), money(v.price));
      show($('[data-price-reference]', r), ref);
      show($('[data-price-reference-note]', r), ref);
      if (ref) {
        txt($('[data-price-reference-value]', r), money(v.low));
        txt($('[data-price-badge]', r), (this.d.strings.discount || '').replace('[percent]', Math.round(((v.low - v.price) * 100) / v.low)));
      }
      const unit = $('[data-price-unit]', r);
      txt(unit, v.unit || '');
      show(unit, !!v.unit);
    }

    /* Positionseigenschaften Material/Lieferumfang der Variante; leer = nicht senden */
    props(v) {
      [['material', v && v.material], ['scope', v && v.scope]].forEach(([k, val]) => {
        const el = $(`[data-prop-${k}]`, this.r);
        if (!el) return;
        el.value = val || '';
        el.disabled = !val;
      });
    }

    initGallery() {
      if (!this.g) return;
      this.vp = $('[data-gallery-viewport]', this.g);
      this.track = $('[data-gallery-track]', this.g);
      if (!this.vp || !this.track || !window.IntersectionObserver) return;
      const io = new IntersectionObserver((es) => es.forEach((en) => en.isIntersecting && this.mark(en.target.dataset.mediaId)), {
        root: this.vp,
        threshold: 0.6,
      });
      $$('[data-media-id]', this.track).forEach((el) => io.observe(el));
    }

    mark(id) {
      $$('[data-gallery-thumb]', this.g).forEach((t) =>
        t.dataset.galleryThumb === id ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current')
      );
    }

    showMedia(id) {
      const item = this.track && $(`[data-media-id="${id}"]`, this.track);
      if (!item) return;
      this.vp.scrollTo({ left: item.offsetLeft - this.track.offsetLeft, behavior: smooth() });
      this.mark(id);
    }

    /* Farbfilter: Medien anderer Farben ausblenden, Variantenbild nach vorn. Ohne Farboption Set-Filter über die Maße
       (product-media-gallery): Set-Ansicht nur bei genau denselben Maßen, Detailbild bei Teilmenge, Variantenbild immer. */
    filter(v) {
      if (!this.g || !this.track) return;
      const c = this.d.colorIndex >= 0 ? v.options[this.d.colorIndex] : '';
      if (c) $$('[data-media-color]', this.g).forEach((el) => el.classList.toggle('is-other-color', !!el.dataset.mediaColor && el.dataset.mediaColor !== c));
      else if (v.sizes && v.sizes.length) {
        const want = new Set(v.sizes.map(String));
        $$('[data-media-sizes]', this.g).forEach((el) => {
          const ms = [...new Set(el.dataset.mediaSizes.split(' ').filter(Boolean))];
          const all = ms.every((s) => want.has(s));
          const fit = el.dataset.mediaKind === 'set' ? all && ms.length === want.size : all;
          const own = v.media && String(v.media) === (el.dataset.mediaId || el.dataset.thumbId);
          el.classList.toggle('is-other-color', !fit && !own);
        });
      }
      if (!v.media) return;
      const id = String(v.media);
      const item = $(`[data-media-id="${id}"]`, this.track);
      if (!item) return;
      this.track.prepend(item);
      const th = $(`[data-thumb-id="${id}"]`, this.g);
      if (th) th.parentElement.prepend(th);
      this.vp.scrollTo({ left: 0, behavior: 'auto' });
      this.mark(id);
    }

    click(e) {
      const t = e.target;
      const thumb = t.closest('[data-gallery-thumb]');
      if (thumb) return this.showMedia(thumb.dataset.galleryThumb);
      /* Kaufleiste bei ausverkaufter Variante: zum Formular „Sag mir Bescheid“ */
      if (t.closest('[data-sticky-button]') && this.btn && this.btn.disabled) {
        e.preventDefault();
        if (this.bis && !this.bis.hidden) {
          this.bis.scrollIntoView({ block: 'center', behavior: smooth() });
          const mail = $('[data-bis-email]', this.bis);
          if (mail) mail.focus({ preventScroll: true });
        }
      }
    }

    /* Kaufleiste erst, wenn der Kauf-Button nach oben aus dem Bild ist (Pflichtangaben stehen davor) */
    initSticky() {
      if (!this.sticky || !this.btn || !window.IntersectionObserver) return;
      new IntersectionObserver(([en]) => {
        const past = !en.isIntersecting && en.boundingClientRect.top < 0;
        this.sticky.hidden = !past;
        document.body.classList.toggle('has-sticky-atc', past);
      }).observe(this.btn);
    }

    updateSticky() {
      const s = this.sticky;
      const v = this.v;
      if (!s) return;
      txt($('[data-sticky-variant]', s), v ? v.title : '');
      if (v) txt($('[data-sticky-price]', s), money(v.price));
      const b = $('[data-sticky-button]', s);
      if (b && this.btn) {
        b.textContent = v && v.available ? this.btn.dataset.labelAdd : b.dataset.labelNotify;
        b.disabled = !v;
      }
    }

    /* Versandschwelle: Warenkorb + Variante × Anzahl (wenn noch nicht im Warenkorb); Bon rechnet mit dem günstigsten
       Artikel aus „Passt dazu“, der die Schwelle erreicht */
    threshold() {
      const t = this.d.threshold;
      const v = this.v;
      if (!t || !v) return;
      const s = this.d.strings;
      const q = Math.max(1, parseInt(this.qty && this.qty.value, 10) || 1);
      const inCart = this.inCart.has(v.id);
      const base = this.cartTotal + (inCart ? 0 : v.price * q);
      const rest = t - base;
      const bar = $('[data-shipping-progress]', this.r);
      if (bar) {
        bar.classList.toggle('shipping-progress--done', rest <= 0);
        const fill = $('[data-shipping-progress-fill]', bar);
        if (fill) fill.style.setProperty('--progress', Math.min(100, Math.floor((base * 100) / t)) + '%');
        const label = $('[data-shipping-progress-label]', bar);
        if (label)
          label.innerHTML = rest > 0 ? (this.cartTotal > 0 ? s.remainingCart : s.remaining).replace('[amount]', money(rest)) : inCart ? s.reached : s.reachedProduct;
      }
      const b = $('[data-bon]', this.r);
      if (!b) return;
      const need = t - v.price;
      const rows = $$('[data-bon-partner]', b);
      let pick = null;
      let best = null;
      rows.forEach((row) => {
        const p = Number(row.dataset.price);
        if (p >= need && (!pick || p < Number(pick.dataset.price))) pick = row;
        if (!best || p > Number(best.dataset.price)) best = row;
      });
      if (need <= 0) pick = null;
      else if (!pick) pick = best;
      rows.forEach((row) => (row.hidden = row !== pick));
      const sum = v.price + (pick ? Number(pick.dataset.price) : 0);
      b.hidden = need > 0 && !rows.length;
      txt($('[data-bon-variant]', b), ', ' + v.title);
      txt($('[data-bon-item]', b), money(v.price));
      txt($('[data-bon-sum]', b), money(sum));
      txt($('[data-bon-ship]', b), money(sum >= t ? 0 : this.d.shipping));
    }
  }

  function init() {
    $$('[data-product-section]').forEach((el) => el._product || (el._product = new Product(el)));
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
